import { Injectable } from '@angular/core';
import { BaseApiHandleOptions, BaseApiService } from './base-api.service';
import { Observable } from 'rxjs';
import { MappingFieldsRequestParamDto } from '../../dto';

@Injectable({
    providedIn: 'root',
})
export class MarketoApiService {
    private url = 'service/contactcloud/marketo';

    constructor(
        private readonly baseApiService: BaseApiService,
    ) { }

    authenticateMarketo(): Observable<any> {
        return this.baseApiService.get(`marketo/authentication`);
    }

    getMarketoClientInfo(type): Observable<any> {
        return this.baseApiService.get(`marketo/authentication/${type}`);
    }

    saveMarketo(value): Observable<any> {
        return this.baseApiService.post(`marketo/authentication`, value);
    }

    testConnection(value): Observable<{ mktUser: string }> {
        return this.baseApiService.post(`marketo/authenticationTest`, value);
    }

    getSettings(): Observable<any> {
        return this.baseApiService.get(`${this.url}/settings`);
    }

    saveSettings(settings): Observable<any> {
        return this.baseApiService.put(`${this.url}/settings`, settings);
    }

    getMappingFields(params: MappingFieldsRequestParamDto = {}): Observable<any> {
        const requestParams = params.isAutomation ? { is_automation: true } : {};
        return this.baseApiService.get(`${this.url}/fields`, { params: requestParams });
    }

    validateDuplicates(value, partitionName): Observable<any> {
        const data = {
            ids: value,
            partitionName: partitionName
        };
        return this.baseApiService.post(`${this.url}/duplicate`, data);
    }

    export(exportType, batchId, ids, partitionName) {
        const data = {
            duplicateResolution: exportType,
            batchId: batchId,
            ids: ids,
            partitionName: partitionName
        };
        return this.baseApiService.post(`${this.url}/export`, data);
    }

    getPartitions(options: BaseApiHandleOptions = {}): Observable<any> {
        return this.baseApiService.get(`${this.url}/partitions`, options);
    }

    logout() {
        return this.baseApiService.get(`marketo/logout`);
    }

    getMarketoEnrichment(payload): Observable<any> {
        return this.baseApiService.post(`${this.url}/enrich/statistics`, payload);
    }

    validateMapping() {
        return this.baseApiService.get(`${this.url}/validateMapping`);
    }
}
